/* Scoop intranet shell – safe storefront navigation and optional authenticated JeriCommerce balance. */
(()=>{
'use strict';
const modal=document.getElementById('ad-scoop-modal');
if(!modal)return;
const $=s=>modal.querySelector(s);
const views=[...modal.querySelectorAll('[data-scoop-view]')];
const shopPrivate=document.getElementById('ad-scoop-shopify-private');
let previousFocus=null,viewVersion=0;
const hub='https://cliente.aldodiego.pe/pages/019f1864-8d9b-7674-8b4d-d15f97aed8c0';
function show(view){
  for(const node of views)node.hidden=node.dataset.scoopView!==view;
  const scroll=$('.ad-scoop-body');if(scroll)scroll.scrollTop=0;
  if(view==='dashboard')loadBalance();
  if(view==='catalog')loadRewards();
  if(view==='profile')loadProfile();
  if(view==='points')loadMovements();

  if(view==='dashboard')loadWallet();
}
function open(){
  previousFocus=document.activeElement;
  const nav=document.getElementById('ad-navigation');
  if(nav?.getAttribute('aria-hidden')==='false')document.getElementById('ad-nav-close')?.click();
  modal.hidden=false;
  document.body.style.overflow='hidden';
  show('welcome');
  $('.ad-scoop-dialog')?.focus();
}
function close(){
  modal.hidden=true;
  viewVersion++;
  document.body.style.overflow='';
  previousFocus?.focus?.();
}
document.addEventListener('click',e=>{
  if(e.target.closest('[data-scoop-open]')){e.preventDefault();open();return;}
  if(e.target.closest('#ad-scoop-modal [data-scoop-close]')){e.preventDefault();close();return;}
  if(e.target.closest('#ad-scoop-modal [data-scoop-menu]')){
    e.preventDefault();close();
    const menu=document.querySelector('#ad-shop .ad-tiles [data-go="delivery"]');
    if(menu)menu.click();else location.href='/collections/all';
    return;
  }
  const popup=e.target.closest('#ad-scoop-modal a[data-scoop-popup]');
  if(popup){
    const w=window.open(popup.href,'_blank','popup=yes,width=550,height=790,resizable=yes,scrollbars=yes');
    if(w){e.preventDefault();try{w.opener=null;}catch{}}
    return;
  }
  const next=e.target.closest('#ad-scoop-modal [data-scoop-next]');
  if(next){e.preventDefault();show(next.dataset.scoopNext);}
});
document.addEventListener('keydown',e=>{if(modal.hidden)return;if(e.key==='Escape'){if(!modal.querySelector('[data-scoop-view="catalog"]')?.hidden)show('welcome');else close();}});
document.addEventListener('click',e=>{if(e.target.closest('#ad-scoop-prev')&&catalogIndex>0){catalogIndex--;renderCatalog();}if(e.target.closest('#ad-scoop-next')&&catalogIndex<catalogRewards.length-1){catalogIndex++;renderCatalog();}});
async function getJeri(){
  if(!window.JeriCommerce?.ready)return null;
  try{return await window.JeriCommerce.ready()||window.JeriCommerce;}catch{return null;}
}
async function loadBalance(){
  const points=$('#ad-scoop-points'),greeting=$('#ad-scoop-greeting');
  const version=++viewVersion;
  points.textContent=shopPrivate?.dataset.balance?.trim()&&Number.isFinite(Number(shopPrivate.dataset.balance))?Number(shopPrivate.dataset.balance).toLocaleString('es-PE')+' puntos':'—';
  
  greeting.textContent='Bienvenido a Mi Scoop.';
  const sdk=await getJeri();
  if(!sdk?.auth?.getSession||!sdk?.customer?.get||version!==viewVersion||modal.hidden)return;
  try{
    const session=await sdk.auth.getSession();
    if(!session?.authenticated)return;
    const result=await sdk.customer.get();
    if(version!==viewVersion||modal.hidden)return;
    const customer=result?.customer;
    if(!customer)return;
    const name=String(customer.userData?.firstName||'').trim();
    if(name)greeting.textContent='¡Hola, '+name+'!';
    const balance=customer.loyaltyData?.balance;
    if(typeof balance==='number'&&Number.isFinite(balance)&&balance>=0){
      points.textContent=balance.toLocaleString('es-PE')+' puntos';
      
    }
  }catch{/* No authenticated balance available. */}
}
let catalogRewards=[],catalogIndex=0;
function renderCatalog(){
 const container=$('#ad-scoop-rewards-list'),counter=$('#ad-scoop-reward-count');
 if(!container)return;
 container.replaceChildren();
 if(!catalogRewards.length){container.textContent='El catálogo no está disponible por ahora.';return;}
 const reward=catalogRewards[catalogIndex],article=document.createElement('article');
 article.className='ad-scoop-reward-feature';
 const title=document.createElement('h3');title.textContent=String(reward.title||reward.name||'Premio Scoop');
 const desc=document.createElement('p');desc.className='ad-scoop-reward-description';
 const source=String(reward.description||reward.shortDescription||'');
 let plain=source;
 for(let pass=0;pass<4;pass++){
  const parsed=new DOMParser().parseFromString(plain,'text/html');
  const next=parsed.body.textContent||'';
  if(next===plain)break;
  plain=next;
 }
 desc.textContent=plain.replace(/\s+/g,' ').trim();
 const cost=document.createElement('strong');cost.className='ad-scoop-reward-cost';cost.textContent=Number(reward.redeemCost).toLocaleString('es-PE')+' puntos';
 const image=reward.imageUrl||reward.image?.url||reward.image;
 if(typeof image==='string'&&image){try{const url=new URL(image,location.origin);if(url.protocol==='https:'&&!url.username&&!url.password){const img=document.createElement('img');img.src=url.href;img.alt=title.textContent;img.loading='lazy';article.append(img);}}catch{}}
 article.append(title,desc,cost);container.append(article);
 if(counter)counter.textContent=(catalogIndex+1)+' / '+catalogRewards.length;
 const prev=$('#ad-scoop-prev'),next=$('#ad-scoop-next');
 if(prev)prev.disabled=catalogIndex===0;
 if(next)next.disabled=catalogIndex===catalogRewards.length-1;
}
async function loadRewards(){
 const container=$('#ad-scoop-rewards-list');if(!container)return;
 const version=++viewVersion;container.textContent='Consultando premios Scoop…';
 try{
  const sdk=await getJeri();if(!sdk?.rewards?.list)throw Error('catalog unavailable');
  const result=await sdk.rewards.list({scope:'public'});
  if(version!==viewVersion||modal.hidden)return;
  catalogRewards=(Array.isArray(result)?result:Array.isArray(result?.data)?result.data:[])
   .filter(x=>x&&Number.isFinite(Number(x.redeemCost))&&Number(x.redeemCost)>0)
   .sort((a,b)=>(Number(a.order)||0)-(Number(b.order)||0));
  catalogIndex=0;renderCatalog();
 }catch{if(version===viewVersion&&!modal.hidden)container.textContent='El catálogo de JeriCommerce no está disponible en esta pantalla por ahora.';}
}

async function authenticatedCustomer(){
  const sdk=await getJeri();
  if(!sdk?.auth?.getSession||!sdk?.customer?.get)return null;
  const session=await sdk.auth.getSession();
  if(!session?.authenticated)return null;
  const response=await sdk.customer.get();
  return response?.customer||null;
}
async function loadProfile(){
  const node=$('#ad-scoop-profile-data');if(!node)return;
  const v=++viewVersion;node.textContent='Consultando tu perfil…';
  try{
    const customer=await authenticatedCustomer();
    if(v!==viewVersion||modal.hidden)return;
    if(!customer&&!shopPrivate){node.textContent='Inicia sesión en Scoop para ver tus datos personales.';return;}
    const u=customer?.userData||{};
    const emailValue=u.email||u.emailAddress?.emailAddress||u.emailAddress||customer?.email;
    const address=u.defaultAddress||u.address||customer?.defaultAddress;
    const formattedAddress=typeof address==='string'?address:address&&typeof address==='object'?[address.address1,address.address2,address.city,address.province].filter(Boolean).join(', '):null;
    const rows=[['Nombre',u.firstName||shopPrivate?.dataset.name],['Apellido',u.lastName||shopPrivate?.dataset.lastname],['Correo electrónico',emailValue||shopPrivate?.dataset.email],['Teléfono',u.phone||u.phoneNumber||shopPrivate?.dataset.phone],['Dirección',formattedAddress||shopPrivate?.dataset.address]];
    node.replaceChildren();
    let found=0;
    for(const [label,value] of rows){
      if(typeof value!=='string'||!value.trim()){if(label==='Correo electrónico'||label==='Dirección'){const p=document.createElement('p'),strong=document.createElement('strong');strong.textContent=label+': ';p.append(strong,document.createTextNode('No disponible'));node.append(p);}continue;}
      const p=document.createElement('p'),strong=document.createElement('strong');
      strong.textContent=label+': ';p.append(strong,document.createTextNode(value));node.append(p);found++;
    }
    if(!found)node.textContent='Tu sesión está activa, pero JeriCommerce no comparte datos de perfil con esta pantalla.';
  }catch{if(v===viewVersion)node.textContent='No fue posible consultar el perfil de forma segura.';}
}
async function loadMovements(){
  const node=$('#ad-scoop-movements');if(!node)return;
  const v=++viewVersion;node.textContent='Consultando movimientos…';
  try{
    const sdk=await getJeri();
    if(!sdk?.auth?.getSession||!sdk?.transactions?.list)throw Error('unavailable');
    const session=await sdk.auth.getSession();
    if(!session?.authenticated){node.textContent='Inicia sesión en Scoop para ver tus movimientos.';return;}
    const result=await sdk.transactions.list();
    if(v!==viewVersion||modal.hidden)return;
    const rows=Array.isArray(result)?result:Array.isArray(result?.data)?result.data:[];
    node.replaceChildren();
    if(!rows.length){node.textContent='No hay movimientos disponibles para mostrar.';return;}
    for(const item of rows.slice(0,20)){
      const p=document.createElement('p');
      const label=String(item?.description||item?.type||'Movimiento');
      const amount=Number(item?.points);
      p.textContent=label+(Number.isFinite(amount)?' · '+amount+' puntos':'');
      node.append(p);
    }
  }catch{if(v===viewVersion)node.textContent='El historial no está disponible desde la integración actual de JeriCommerce.';}
}


function loadWallet(){
 const node=$('#ad-scoop-wallet-action'),note=$('#ad-scoop-card-note'),detail=$('#ad-scoop-wallet-detail');
 if(!note)return;
 if(node)node.replaceChildren();if(detail)detail.replaceChildren();
 const raw=shopPrivate?.dataset.wallet;
 if(!raw){note.textContent='Tu QR personal aún no está disponible en esta pantalla.';return;}
 try{
   const url=new URL(raw,location.origin);
   if(url.protocol!=='https:'||url.username||url.password)throw Error('invalid wallet URL');
   const a=document.createElement('a');
   a.className='ad-scoop-card-action';a.href=url.href;a.target='_blank';a.rel='noopener noreferrer';
   a.textContent='Agregar tarjeta oficial a Wallet ↗';
   if(node)node.append(a);if(detail)detail.append(a.cloneNode(true));note.textContent='Tu tarjeta digital oficial de Scoop.';
 }catch{note.textContent='La tarjeta digital no está disponible por ahora.';}
}
function loadOrders(){
 const node=$('#ad-scoop-orders-list');if(!node)return;
 node.replaceChildren();
 if(!shopPrivate){node.textContent='Para consultar tus pedidos aquí se necesita autorizar la sesión de Shopify.';return;}
 const orders=[...shopPrivate.querySelectorAll('[data-order-name]')];
 if(!orders.length){node.textContent='No encontramos pedidos en esta cuenta.';return;}
 for(const item of orders){
  const p=document.createElement('p');
  p.textContent=[item.dataset.orderName,item.dataset.orderDate,item.dataset.orderTotal].filter(Boolean).join(' · ');
  node.append(p);
 }
}

if(location.hash==='#scoop')open();
})();